import { Component, Inject, ElementRef,ViewChild, Optional, OnInit,Injectable } from '@angular/core';
import { MatDialog,MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UtilsService } from '../../../services/utils.service';
import { TipoEvaluacionService } from '../../../services/tipo-evaluacion.service';
import { EstructuraJerarquicaService } from '../../../services/estructura-jerarquica.service';
import { EstructuraJerarquica } from 'app/main/models/estructura-jerarquica.model';
import { NodoEstructuraJerarquica } from 'app/main/models/nodo-estructura-jerarquica.model';
import { TipoEvaluacion } from 'app/main/models/tipo-evaluacion.model';
import { MatTable } from '@angular/material/table';
import { NodoDialogBoxComponent } from './nodo-dialog-box.component';
import { DialogBoxTreeComponent } from './dialog-box-tree.component';

import {SelectionModel} from '@angular/cdk/collections';
import {FlatTreeControl} from '@angular/cdk/tree';
import {MatTreeFlatDataSource, MatTreeFlattener} from '@angular/material/tree';
import {BehaviorSubject} from 'rxjs';

import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {FormControl} from '@angular/forms';
import {MatAutocompleteSelectedEvent, MatAutocomplete} from '@angular/material/autocomplete';
import {MatChipInputEvent} from '@angular/material/chips';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import { first } from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';
import {MatSnackBar} from '@angular/material/snack-bar';

import { DialogBoxPrintComponentEstructuraJerarquica } from './dialog-print-box.component';
import { DialogBoxAddNodeComponent } from './dialog-box-add-node.component';




interface ExampleFlatNode {
  expandable: boolean;
  name: string;
  //descripcion: string;
  level: number;
}

@Component({
  selector: 'app-dialog-box',
  templateUrl: './dialog-box.component.html',
  styleUrls: ['./dialog-box.component.scss']
})
export class DialogBoxComponent {

  displayedColumns: string[] = ['nombre','padre','descripcion','action'];
  action: string;
  LOCAL_DATA: any;

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  tipoCtrl = new FormControl();
  filteredTipos: Observable<TipoEvaluacion[]>;

  private _transformer = (node: NodoEstructuraJerarquica, level: number) => {
    return {
      expandable: !!node.hijos && node.hijos.length > 0,
      name: node.nombre,
      descripcion: node.descripcion,
      level: level,
      usuarios: node.usuarios,
      evaluaciones: node.evaluaciones,
      id: node.id
    };
  }

  treeControl = new FlatTreeControl<ExampleFlatNode>(
      node => node.level, node => node.expandable);

  treeFlattener = new MatTreeFlattener(
      this._transformer, node => node.level, node => node.expandable, node => node.hijos);

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
  dataSourceList = [];
  tiposEvaluacion = [];
  isLoaded = false;

  @ViewChild('tipoInput') tipoInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;
  @ViewChild(MatTable, {static: true}) table: MatTable<any>;

  constructor(
    public dialog: MatDialog,
    public translate: TranslateService,
    private _snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<DialogBoxComponent>,
    public service:TipoEvaluacionService,
    public serviceEstructura:EstructuraJerarquicaService,
    public utils:UtilsService,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {

    this.dialogRef.disableClose = true;
    console.log(data);
    this.LOCAL_DATA = {...data.obj};
    this.dataSourceList = data.dataSource;
    this.LOCAL_DATA.nodos = data.obj.nodos || [];
    this.orderStructure(this.LOCAL_DATA.nodos);
    this.dataSource.data = this.LOCAL_DATA.nodos;

    this.action = data.action;
    if(this.action=='Add')
      this.isLoaded = true;
  }

  print():void{

    const dialogRef = this.dialog.open(DialogBoxPrintComponentEstructuraJerarquica, {
      width: '100%',
      data: {action:"Print", obj:this.LOCAL_DATA},
      autoFocus: false,
      disableClose: true
    });

  }

  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;

  doAction(): void{
    console.log('im here');
    this.dialogRef.close({event: this.action, data: this.LOCAL_DATA,dataSource:this.dataSourceList});
  }

  closeDialog(): void{
    this.dialogRef.close({event: 'Cancel'});
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    if(this.LOCAL_DATA.tipoEvaluacion == undefined){
      this.LOCAL_DATA.tipoEvaluacion = [];
    }
    // Add our fruit
    if ((value || '').trim()) {
      this.LOCAL_DATA.tipoEvaluacion.push(value.trim());
    }
    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  remove(categoria: any): void {
    const index = this.LOCAL_DATA.tipoEvaluacion.indexOf(categoria);

    if (index >= 0) {
      this.LOCAL_DATA.tipoEvaluacion.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    if(this.LOCAL_DATA.tipoEvaluacion == undefined){
      this.LOCAL_DATA.tipoEvaluacion = [];
    }
    this.LOCAL_DATA.tipoEvaluacion.push(event.option.value);
    this.tipoInput.nativeElement.value = '';
    this.tipoCtrl.setValue(null);
  }

  private _filter(value: TipoEvaluacion): TipoEvaluacion[] {
    const filterValue = value.nombre.toLowerCase();
    return this.tiposEvaluacion.filter(tipo => value.nombre.toLowerCase().indexOf(filterValue) === 0);
  }

  ngOnInit(): void {

    this.serviceEstructura.get(this.LOCAL_DATA.id).pipe().subscribe(req => {
      this.LOCAL_DATA = new EstructuraJerarquica(req.body);
      //this.dataSourceList = data.dataSource;
      this.orderStructure(this.LOCAL_DATA.nodos);
      this.dataSource.data = [...this.LOCAL_DATA.nodos];
      this.isLoaded = true;
    });

    this.service.getAll(0,1000).pipe().subscribe(req => {
      this.tiposEvaluacion = req.body.map( tipo => {
        console.log(tipo);
        return {
          id: tipo.id,
          nombre: tipo.nombre
        };
      });

      this.filteredTipos = this.tipoCtrl.valueChanges.pipe(
        startWith(null),
        map((tipo: TipoEvaluacion | null) => tipo ? this._filter(tipo) : this.tiposEvaluacion.slice()));
    });
  }

  openDialog(action, obj): void {
    obj.action = action;
    obj.info = this.LOCAL_DATA;
    const dialogRef = this.dialog.open(DialogBoxTreeComponent, {
      width: '100%',
      data: obj,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {

      if(result.event=='Modifier'){
          this.ngOnInit();
      }else if(result.event!='Cancel'){
        this.LOCAL_DATA.nodos = [...result.data];
        this.dataSource.data = [...this.LOCAL_DATA.nodos];
      }else{
        this.LOCAL_DATA.nodos = [...result.data];
      }

    });
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 3000,
    });
  }

  orderStructure(nodos):void{

    for(var z=0; nodos.length>z;z++){
      nodos.sort(this.utils.sortAlphaNum);
      this.orderStructure(nodos[z].hijos);
    }
  }

  viewItem(nodo: NodoEstructuraJerarquica) {

    const dialogRef = this.dialog.open(DialogBoxAddNodeComponent, {
      width: '100%',
      data: {action:'View',obj:nodo},
      disableClose: true
    });

  }


}
